/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React from "react";

import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader } from "@forge/common";

import "./styles.scss";

interface LandingPageProps {
  titleKey: string;
  h2Text: string;
  h3Text: string;
  linkText?: string;
  buttonOnClick?: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ titleKey, h2Text, h3Text, linkText, buttonOnClick }) => {
  const { t } = useTranslation();
  return (
    <Card className="no-device-card">
      <CardHeader
        className="no-device-card-header"
        title={t(titleKey)}
      />
      <CardContent top="none" className="no-device-content">
        <img src="/img/no-device.svg" alt="No device" />
        <h2>{h2Text}</h2>
        <h3>{h3Text} {linkText && <span className="text-blue-600 cursor-pointer" onClick={buttonOnClick}>{linkText}</span>}</h3>
      </CardContent>
    </Card>
  );
};

export default LandingPage;
